export default "__VITE_ASSET__C_M4yFwi__"